import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class StructuredDataService {
    private structuredDataScript: HTMLScriptElement | null = null;

    constructor(@Inject(DOCUMENT) private document: Document) { }

    /**
     * Adds JSON-LD structured data to the page
     * @param type Schema.org type (e.g., 'Organization', 'WebPage')
     * @param data The structured data object
     */
    addStructuredData(type: string, data): void {
        // Remove existing schema if present
        this.removeStructuredData();

        // Create the JSON-LD script element
        const script = this.document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify({
            '@context': 'https://schema.org',
            '@type': type,
            ...data
        });

        // Add to document head
        this.document.head.appendChild(script);
        this.structuredDataScript = script;
    }

    /**
     * Removes previously added structured data
     */
    removeStructuredData(): void {
        if (this.structuredDataScript) {
            this.document.head.removeChild(this.structuredDataScript);
            this.structuredDataScript = null;
        }
    }

    /**
     * Adds Organization schema to the page
     * @param config Organization configuration
     */
    addOrganizationSchema(config: {
        name: string,
        url: string,
        logo?: string,
        contactPoint?: any
    }): void {
        this.addStructuredData('Organization', config);
    }

    /**
     * Adds WebPage schema to the page
     * @param config WebPage configuration
     */
    addWebPageSchema(config: {
        name: string,
        description: string,
        url: string
    }): void {
        this.addStructuredData('WebPage', config);
    }
}
